var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_22176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#FF2147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9044 12.3729C7.64002 12.3729 7.37565 12.3729 7.11127 12.3729C6.9319 12.3729 6.8119 12.2572 6.81127 12.0785C6.8769 10.0194 6.44033 10.1766 7.92658 10.1851C9.35471 10.1747 8.93252 10.0351 8.99815 12.0532C8.99815 12.2629 8.88846 12.3729 8.68033 12.3732L7.9044 12.3729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87184 9.74987C7.61309 9.74987 7.35434 9.748 7.09559 9.74987C6.88434 9.76331 6.84309 9.52237 6.81434 9.36393C6.74091 8.68018 7.02528 8.14925 7.52841 7.71175C7.88153 7.37393 8.36466 7.23268 8.73841 6.92768C9.08653 6.62737 9.05091 6.1205 8.67997 5.85362C8.27622 5.56425 7.63372 5.53393 7.21966 5.80175C6.92684 6.00737 6.71091 6.30925 6.47903 6.57893C6.34216 6.74175 6.20684 6.75924 6.03778 6.63112C5.68257 6.36195 5.32841 6.09185 4.97528 5.82081C4.82591 5.70643 4.80622 5.57393 4.90372 5.41456C5.88184 3.62706 8.36872 3.04581 9.99997 4.28956C11.0937 5.00112 11.5765 6.6005 10.7265 7.67893C10.3943 8.14768 9.83091 8.35268 9.38997 8.69518C8.76747 9.21862 9.15622 9.71112 8.64841 9.74987C8.38966 9.74987 8.1308 9.74987 7.87184 9.74987Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_22176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.98402f997bb3d592265ed8d4bd7f7598.svg";
export { ForwardRef as ReactComponent };